import { connect } from 'react-redux';
import { compose, withStateHandlers } from 'recompose';

import { getAppointmentDetails } from 'modules/appointmentInfo/selectors/currentAppointmentDetails';
import { getReadCurrentAppointmentPermissions } from 'modules/appointmentInfo/selectors/currentAppointment';

import AppointmentDetails from './AppointmentDetails';

const mapStateToProps = (state) => ({
  ...getAppointmentDetails(state),
  permissions: getReadCurrentAppointmentPermissions(state),
});

export default compose(
  connect(mapStateToProps),

  withStateHandlers(
    { expanded: true },
    { expandPanel: ({ expanded }) => () => ({ expanded: !expanded }) },
  ),
)(AppointmentDetails);
